/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Of_Landing_Act_JoinInputs */

const en_of_landing_act_join = /** @type {(inputs: Of_Landing_Act_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join in a click`)
};

const id_of_landing_act_join = /** @type {(inputs: Of_Landing_Act_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gabung dalam satu klik`)
};

/**
* | output |
* | --- |
* | "Join in a click" |
*
* @param {Of_Landing_Act_JoinInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const of_landing_act_join = /** @type {((inputs?: Of_Landing_Act_JoinInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Of_Landing_Act_JoinInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_of_landing_act_join(inputs)
	return en_of_landing_act_join(inputs)
});